import React from "react";
import ReactECharts from "echarts-for-react";
import { Box } from "@mui/material";
import useOTBStyle from "../OTBStyle";

const BarChartComponent = ({
  data,
  keyValue,
  title,
  height = "550px",
  width = "100%",
  notPdf,
}) => {
  const classes = useOTBStyle();

  // const groupBy = (key) =>
  //   data?.reduce((acc, item) => {
  //     const value = item[key];
  //     acc[value] = acc[value] || [];
  //     acc[value].push(item);
  //     return acc;
  //   }, {});

  const groupBy = (key) =>
    data?.reduce((acc, item) => {
      const result = item[key]?.result;
      if (result !== undefined) {
        acc[result] = acc[result] || [];
        acc[result].push(item);
      }
      return acc;
    }, {});

  const xyAxisData = Object?.entries(groupBy(keyValue) || {})?.map(
    ([key, items]) => ({
      name: key,
      value: items.length,
    })
  );

  const xAxisData = xyAxisData.map((item) => item.name);
  const seriesData = xyAxisData.map((item) => item.value);

  const barColors = [
    "#B29263",
    "#D5B98B",
    "#E8D0B1",
    "#B3B3B3",
    "#808080",
    "#666666",
    "#444444",
  ];

  return (
    <Box>
      <ReactECharts
        option={{
          grid: {
            top: 10,
            bottom: 80,
            right: 20,
            left: 50,
          },
          xAxis: {
            type: "category",
            data: xAxisData,
            name: title ?? "",
            nameLocation: "middle",
            nameGap: 100,
            nameTextStyle: {
              verticalAlign: "middle",
            },
            axisLabel: {
              formatter: (value) => {
                return notPdf ? value : value.split(" ").join("\n");
              },
              rotate: 0,
              interval: 0,
              fontSize: notPdf ? 14 : 10,
              color: "#000",
              fontWeight: 600,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#6E7079",
                width: 1,
              },
            },
          },
          yAxis: {
            type: "value",
            min: 0,
            max: data?.length ?? [],
            name: "Counts",
            nameLocation: "middle",
            nameGap: 30,
            nameTextStyle: {
              fontSize: 14,
              color: "#0A0A0B",
              fontWeight: 600,
            },
            axisLabel: {
              fontSize: 14,
              color: "#000",
              fontWeight: 600,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#6E7079",
                width: 1,
              },
            },
          },
          series: [
            {
              data: seriesData,
              type: "bar",
              barWidth: 50,
              itemStyle: {
                color: (params) => barColors[params.dataIndex] || "#000",
              },
              label: {
                show: true,
                position: "top",
                fontSize: 14,
                fontWeight: "bold",
                color: "#333",
              },
              animation: false,
              animationDuration: 0,
              animationDurationUpdate: 0,
            },
          ],
          tooltip: {
            trigger: "axis",
            formatter: (params) => {
              const data = params[0];
              return `${data.name}: ${data.value}`;
            },
          },
        }}
        style={{ height, width }}
      />
    </Box>
  );
};

export default BarChartComponent;
